import { render } from "./SvgList.vue?vue&type=template&id=6a30229c"
import script from "./SvgList.vue?vue&type=script&lang=js"
export * from "./SvgList.vue?vue&type=script&lang=js"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__